import axios, { AxiosError, AxiosInstance } from 'axios';
import { filterErrorsWhiteList } from './interceptor/errorHandler';
import { axiosMock } from './mocks/axiosMock';
import { setupCache } from 'axios-cache-interceptor';

export function axiosInstance(): AxiosInstance {
  const axiosBack = axios.create({
    baseURL: (window as unknown as WindowWithEnv)._env_.msHostname,
    headers: { keyId: (window as unknown as WindowWithEnv)._env_.keyId || '' },
    timeout: 30000,
    timeoutErrorMessage: 'ECONNTIMEOUT',
  });

  const cachedAxios = setupCache(axiosBack, {
    ttl: 60 * 60 * 1000,
    methods: ['get'],
  });

  cachedAxios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      return response;
    },
    function (error: AxiosError) {
      return filterErrorsWhiteList(error);
    },
  );

  return /^true$/i.test((window as unknown as WindowWithEnv)._env_.useMock || 'false') ? axiosMock() : axiosBack;
}
